import { Viewer } from './viewer/Viewer';
import type { CameraAngle } from './config/exercise3d';

interface ViewerScreenProps {
  modelName: string;
  exerciseName: string | null;
  setIndex: number | null;
  isPaused: boolean;
  playbackSpeed: number;
  cameraAngle: CameraAngle;
  rotationAngle: number | undefined;
  phase: 'countdown' | 'active' | 'rest' | 'complete' | null;
  timerSeconds: number | null;
  disconnected: boolean;
}

export function ViewerScreen({
  modelName,
  exerciseName,
  setIndex,
  isPaused,
  playbackSpeed,
  cameraAngle,
  rotationAngle,
  phase,
  timerSeconds,
  disconnected,
}: ViewerScreenProps) {
  return (
    <div className="viewer-screen">
      <Viewer
        modelName={modelName}
        isPaused={isPaused}
        playbackSpeed={playbackSpeed}
        cameraAngle={cameraAngle}
        rotationAngle={rotationAngle}
      />

      <div className="viewer-overlay-top">
        {exerciseName && (
          <div className="viewer-exercise-name">
            {exerciseName}
            {setIndex != null && <span className="viewer-set"> · Set {setIndex}</span>}
          </div>
        )}
        {phase === 'countdown' && timerSeconds != null && (
          <div className="viewer-phase viewer-phase--countdown">{timerSeconds}</div>
        )}
        {phase === 'rest' && timerSeconds != null && (
          <div className="viewer-phase viewer-phase--rest">Rest · {timerSeconds}s</div>
        )}
        {phase === 'complete' && <div className="viewer-phase">Workout complete 🎉</div>}
      </div>

      {disconnected && (
        <div className="viewer-disconnected">
          <div className="viewer-disconnected-title">Phone disconnected</div>
          <div className="viewer-disconnected-sub">Reconnect from your phone to resume</div>
        </div>
      )}
    </div>
  );
}
